var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"header"},[_c('section',{staticClass:"header-inner"},[_vm._t("logo"),_vm._t("nav")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }